import React from 'react';
import { EmptyCardWrapper } from './EmptyCard.styled';

const EmptyCard = (children: React.ReactNode) => {
  return <EmptyCardWrapper>{children}</EmptyCardWrapper>;
};

export { EmptyCard };
